import type { ConditionType } from '@validators/types'

export const users: ConditionType = {
	name: {
		rules: ['require', 'isUserName', 'isLength[{"min": 0, "max": 20}]'],
		message: {
			require: '필수 입력 항목입니다.',
			isUserName: '문자와 띄워쓰기만 가능합니다.',
			isLength: '20자 이내로 입력해주세요.',
		},
	},
	profileImageUrl: {
		rules: [],
		message: {},
	},
	email: {
		rules: ['isEmail'],
		message: {
			isEmail: '이메일 형식으로 입력해주세요.',
		},
	},
	language: {
		rules: [],
		message: {},
	},

	password: {
		rules: ['require', 'password', 'isLength[{"min": 8, "max": 20}]'],
		message: {
			require: '필수 입력 항목입니다.',
			password: '패스워드 형식이 아닙니다.',
			isLength: '8~20자 이내로 입력해주세요.',
		},
	},
	useYn: {
		rules: [],
		message: {},
	},
	confirmPassword: {
		rules: ['require', 'equals'],
		message: {
			require: '필수 입력 항목입니다.',
			equals: '패스워드를 다시 확인해주세요.',
		},
		equalsWith: 'password',
	},
}

export default users
